import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import { map, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { AppComponent } from '@app/app.component';
import { Code } from '@app/models/code';
import { HttpService } from '@app/services/http.service';
import { LoaderService } from '@app/services/loader.service';
import { SnackbarService } from '@app/services/snackbar.service';
import { PageTitleService } from '@app/services/page-title.service';
import { environment } from '@env/environment';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { BaseComponent } from '@app/base.component';

@Component({
  selector: 'app-code-select',
  templateUrl: './code-select.component.html',
  styleUrls: ['./code-select.component.css']
})
export class CodeSelectComponent extends BaseComponent implements OnInit {

  // local variables
  codes: MatTableDataSource<Code> = new MatTableDataSource<Code>([]);
  urlBack: string = null;
  
  // viewchild objects
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;
  
  columnsToDisplay: string[] = ['edit', 'code_id', 'code', 'code_order', 'code_type', 'description'];
  themeColor: ThemePalette = 'primary';
  isHandset$: Observable<boolean> = this.breakpointObserver.observe( Breakpoints.Handset )
    .pipe(
      map( result => result.matches ),
      shareReplay()
    );

  constructor(
    private pageTitleService: PageTitleService,
    private appComponent: AppComponent,
    private router: Router,
    private httpService: HttpService,
    private loaderService: LoaderService,
    private breakpointObserver: BreakpointObserver,
    private snackbarService: SnackbarService
  ) {
    super();
  }

  ngAfterViewInit() {
   this.codes.sort = this.sort;
  }

  ngOnInit(): void {
    this.isHandset$
    .pipe( takeUntil( this.appUnsubscribe ) )
    .subscribe( result => {
      if (result) {
        this.columnsToDisplay = ['edit', 'code', 'code_type'];
      } else {
        this.columnsToDisplay = ['edit', 'code', 'code_type', 'description', 'code_order', 'is_active'];
      }
    });
    this.loaderService.show();

    this.appComponent.appendSiteTitle('Code', 'Select');
    this.pageTitleService.setPageTitle('Code Administration');

    this.urlBack = this.router.createUrlTree([ '/' ]).toString();
    this.fetchCodes();

    this.snackbarService.showPendingMessage();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.codes.filter = filterValue.trim().toLowerCase();
    if (this.codes.paginator) {
      this.codes.paginator.firstPage();
    }
  }

  handleBack(): void {
    this.router.navigateByUrl( this.urlBack );
  }

  handleRowAdd(): void {
    this.router.navigate(['administration', 'code', 'create']);
  }

  handleRowEdit(code: Code): void {
    this.router.navigate(['administration', 'codes', code.code_id]);
  }

  fetchCodes(): void {
    let urlApi: string = this.httpService.createUrl([
      'api',
      'codes'
    ], {}, { host: environment.host_api_default });

    this.httpService.get<Code[]>(urlApi).pipe(
      tap( _ => null )
    ).subscribe(data => {
      this.codes = new MatTableDataSource(data);
      this.codes.sort = this.sort;
    }, () => {
      // do nothing
    }, () => {
      this.loaderService.hide();
    });
  }
  
}
